<template>
    <transition name="fade">
        <div :class="['order-remark', { 'inline-mode': inline }]">
            <div class="content">
                <Icon v-if="!inline" type="md-close" size="18" class="close-btn" @click="$emit('close')" />
                <div class="order-logistics-box">
                    <div class="logistics-top">
                        <div class="top-left">
                            <img src="@/assets/images/shop-manage/icon-shop-order-logistics.png" alt=""
                                class="logistics-top-icon" />
                            <div class="logistics-top-status">
                                <div class="logistics-top-text">物流跟踪</div>
                                <div class="logistics-top-line">|</div>
                                <div class="logistics-status">{{ getStatusText(currentStatus) }}</div>
                            </div>
                        </div>
                        <div class="top-right" v-if="!is_direct">本订单共包含{{ deliveryList.length }}个物流单</div>
                    </div>
                    
                    <div class="logistics-package-list" v-if="deliveryList.length > 1">
                        <div v-for="(delivery, idx) in deliveryList" :key="delivery.id"
                            :class="['package-item', { 'active': currentDeliveryIndex == idx }]"
                            @click="switchTab(idx)">
                            包裹{{ idx + 1 }}
                        </div>
                    </div>
                    
                    <div class="logistics-info-box">
                        <div class="logistics-info-left">
                            <img src="@/assets/images/shop-manage/img-shop-order-logistics.png" alt=""
                                class="logistics-img" />
                            <div class="logistics-info-title">物流信息</div>
                            <div class="logistics-info-content">
                                <div class="logistics-info-item">
                                    <div class="label">快递单号：</div>
                                    <div class="value">{{ currentExpress.logistics_no || '--' }}</div>
                                </div>
                                <div class="logistics-info-item">
                                    <div class="label">快递公司：</div>
                                    <div class="value">{{ currentExpress.logistics_name || '--' }}</div>
                                </div>
                                <div class="logistics-info-item">
                                    <div class="label">发货时间：</div>
                                    <div class="value">{{ currentExpress.send_time || '--' }}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="logistics-info-right">
                            <div class="logistics-router-box">
                                <template v-if="currentTrackingList.length">
                                    <div class="logistics-router-item" 
                                         v-for="(item, index) in currentTrackingList" 
                                         :key="index">
                                        <div class="router-item-left" :class="{ active: index === 0 }">
                                            {{ formatTime(item.opTime) }}
                                        </div>
                                        <div :class="['router-item-center', { active: index == 0 }]"></div>
                                        <div class="router-item-right">
                                            <div class="status" :class="{ active: index === 0 }">
                                                {{ item.opDesc || item.addressText }}
                                            </div>
                                            <div class="status-desc" :class="{ active: index === 0 }">
                                                {{ item.opMessage }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div v-else class="empty-tracking">
                                    暂无物流轨迹 
                                    <a style="margin-left: 4px; cursor: pointer;" @click="onRefresh">重试</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <template v-if="showProducts">
                    <div class="logistics-products-list-title">
                        物流订单包含{{ currentProducts.length }}个货品
                    </div>

                    <div class="logistics-products-list">
                        <div class="products-item" 
                             v-for="(item, index) in currentProducts" 
                             :key="index">
                            <img :src="item.product_image || '' | default_img" alt="" class="products-cover" />
                            <div class="title-spec-num">
                                <div class="title">{{ item.product_name || '' }}</div>
                                <div class="spec-num">
                                    <div class="spec" v-if="item.spec_info">
                                        <div class="color">{{ item.spec_info }}</div>
                                    </div>
                                    <div class="num">X{{ item.num || item.quantity || item.goods_num || 1 }}</div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 如果没有商品数据，显示提示 -->
                        <div v-if="!currentProducts.length" class="no-products">
                            暂无商品信息
                        </div>
                    </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { GetMallOrderDeliveries, GetLogisticsTracking } from '@/api/index';

export default {
    name: "OrderRemark",
    data() {
        return {
            currentDeliveryIndex: 0,
            currentStatus: 'TRANSPORT',
            trackingMap: {},  // 存储每个物流单号的轨迹信息
            deliveryList: [],  // 物流列表
            loading: false,
        }
    },
    props: {
        order: {
            type: Object,
            default: () => ({})
        },
        // 内嵌模式：不渲染全屏遮罩/关闭按钮，由外层弹窗(如iview Modal)承载
        inline: {
            type: Boolean,
            default: false
        },
        // 直查模式：直接按快递公司+单号查轨迹(售后物流没有订单配送单)
        logistics_name: {
            type: String,
            default: ''
        },
        logistics_no: {
            type: String,
            default: ''
        },
        // 直查模式下的发货时间
        send_time: {
            type: [String, Number],
            default: ''
        },
        // 直查模式下展示的货品列表
        goods_list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        // 直查模式：外部直接传了快递单号
        is_direct() {
            return !!this.logistics_no;
        },
        showProducts() {
            if (!this.is_direct) return true;
            return this.goods_list && this.goods_list.length > 0;
        },
        currentExpress() {
            return this.deliveryList[this.currentDeliveryIndex] || {};
        },
        currentTrackingList() {
            const expressId = this.currentExpress.id;
            return expressId ? (this.trackingMap[expressId] || []) : [];
        },
        // 当前包裹包含的商品
        currentProducts() {
            // 直查模式直接用外部传入的货品
            if (this.is_direct) return this.goods_list || [];
            if (!this.currentExpress.goods_ids) return [];
            const goodsIds = String(this.currentExpress.goods_ids)
                .split(',')
                .map(id => id.trim())
                .filter(id => id);
        
            if (this.order.goods && this.order.goods.length) {
                return this.order.goods.filter(goods => {
                    return goodsIds.includes(String(goods.og_id));
                });
            }
            return [];
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        // 初始化数据
        async initData() {
            // 直查模式：外部传入快递公司+单号(售后物流)
            if (this.is_direct) {
                this.deliveryList = [{
                    id: 'direct',
                    logistics_name: this.logistics_name,
                    logistics_no: this.logistics_no,
                    send_time: this.send_time,
                }];
                await this.queryDeliveryLogistics(this.deliveryList[0]);
                this.updateCurrentStatus();
                return;
            }

            const { order_id } = this.order;
            if (!order_id) {
                this.$layer.msg('订单ID不存在');
                return;
            }
            await this.getDeliveries(order_id);
        },
        
        // 切换包裹标签
        async switchTab(idx) {
            if (idx === this.currentDeliveryIndex) return;
            
            this.currentDeliveryIndex = idx;
            const delivery = this.deliveryList[idx];
            
            // 如果该包裹的轨迹还没有查询过，则查询
            if (delivery && delivery.id && !this.trackingMap[delivery.id]) {
                await this.queryDeliveryLogistics(delivery);
            }
            
            // 更新当前状态
            this.updateCurrentStatus();
        },
        
        // 更新当前状态
        updateCurrentStatus() {
            const traces = this.currentTrackingList;
            this.currentStatus = traces.length > 0 ? traces[0].opCode : 'TRANSPORT';
        },
        
        // 获取状态文本
        getStatusText(opCode) {
            const statusMap = {
                'TRANSPORT': '运输中',
                'DELIVERING': '派送中',
                'SIGN': '已签收',
                'AGENT_SIGN': '待提货',
                'ACCEPT': '已揽收',
                'OUTBOUND': '已发出',
                'INBOUND': '已到达',
                'DELIVERY': '派送中',
                'FAILED': '异常',
                'PICKUP': '已取件',
                'PACKAGE': '已打包',
                'SIGN_FAILED': '签收失败',
                'REJECTED': '已拒收',
                'CANCELED': '已取消',
                'RETURN': '退回',
                'RETURN_SIGN': '退回签收',
            };
            return statusMap[opCode] || '运输中';
        },
        
        // 格式化时间
        formatTime(time) {
            if (!time) return '--';
            // 如果时间格式已经是 YYYY-MM-DD HH:mm:ss，直接返回
            if (typeof time === 'string' && time.includes('-')) {
                return time;
            }
            // 如果是时间戳，转换格式
            const date = new Date(time);
            if (isNaN(date.getTime())) return time;
            
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        
        // 重试
        onRefresh() {
            const delivery = this.currentExpress;
            if (delivery && delivery.id) {
                // 清除缓存，重新查询
                this.$delete(this.trackingMap, delivery.id);
                this.queryDeliveryLogistics(delivery);
            }
        },
        
        // 获取物流列表
        async getDeliveries(order_id) {
            try {
                this.loading = true;
                const { code, msg, data } = await GetMallOrderDeliveries({ order_id });
                
                if (code > 0) {
                    this.$layer.msg(msg || '获取物流信息失败');
                    return;
                }
                
                this.deliveryList = data || [];
                
                // 查询所有配送的物流轨迹
                if (this.deliveryList.length > 0) {
                    // 并行查询所有物流轨迹
                    await Promise.all(
                        this.deliveryList.map(delivery => this.queryDeliveryLogistics(delivery))
                    );
                    
                    // 更新当前状态
                    this.updateCurrentStatus();
                }
            } catch (e) {
                console.error('获取物流信息失败:', e);
                this.$layer.msg(e.msg || '获取物流信息失败');
            } finally {
                this.loading = false;
            }
        },
        
        // 查询单个配送的物流轨迹
        async queryDeliveryLogistics(delivery) {
            if (!delivery || !delivery.logistics_no) return;
            
            // 如果已经查询过，直接返回
            if (this.trackingMap[delivery.id]) {
                return this.trackingMap[delivery.id];
            }
            
            try {
                const params = {
                    logistics_name: delivery.logistics_name,
                    logistics_no: delivery.logistics_no,
                };
                // delivery.phone: 收件人手机号,顺丰等物流需此参数才能查询轨迹
                if (delivery.phone) {
                    params.phone = delivery.phone;
                }
                
                const { code, msg, data } = await GetLogisticsTracking(params);
                
                if (code > 0) {
                    console.warn('查询物流轨迹失败:', msg);
                    // 设置空数组，避免重复查询
                    this.$set(this.trackingMap, delivery.id, []);
                    return [];
                }
                
                // 兼容不同的返回结构
                let traceList = [];
                if (data && Array.isArray(data)) {
                    traceList = data;
                } else if (data && data.traceList && Array.isArray(data.traceList)) {
                    traceList = data.traceList;
                } else if (data && data.traces && Array.isArray(data.traces)) {
                    traceList = data.traces;
                }
                
                // 使用 $set 确保响应式更新
                this.$set(this.trackingMap, delivery.id, traceList);
                
                return traceList;
            } catch (e) {
                console.error('查询物流轨迹失败:', e);
                this.$set(this.trackingMap, delivery.id, []);
                return [];
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.order-remark {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: none !important;
    transform-origin: unset !important;

    // 内嵌模式(外层由iview Modal承载):去掉全屏遮罩与自身容器约束
    &.inline-mode {
        position: static;
        width: 100%;
        height: auto;
        background: transparent;
        display: block;

        .content {
            width: 100%;
            max-height: none;
            background-color: transparent;
            padding: 0;
            border-radius: 0;
            overflow: visible;
        }
    }

    .content {
        width: 1200px;
        max-height: 800px;
        background-color: #fff;
        padding: 24px;
        position: relative;
        border-radius: 10px;
        overflow: auto;
    }

    .close-btn {
        position: absolute;
        top: 14px;
        right: 14px;
        font-size: 18px;
        cursor: pointer;
    }

    .order-logistics-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 16px;
        padding-bottom: 36px;


        .logistics-top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .top-left {
                display: flex;
                align-items: center;
                column-gap: 20px;

                .logistics-top-icon {
                    width: 64px;
                    height: 64px;
                }

                .logistics-top-status {
                    display: flex;
                    column-gap: 12px;
                    align-items: center;

                    .logistics-top-text {
                        color: #333;
                        font-size: 16px;
                    }

                    .logistics-top-line {
                        color: #e3e3e3;
                        font-size: 20px;
                    }

                    .logistics-status {
                        color: #02c160;
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
            }

            .top-right {
                color: #666;
                font-size: 14px;
            }
        }

        .logistics-package-list {
            width: 100%;
            display: flex;
            align-items: center;
            column-gap: 10px;
            margin-top: 16px;

            .package-item {
                color: #666;
                font-size: 16px;
                height: 32px;
                line-height: 32px;
                padding: 0 30px;
                border-radius: 16px;
                border: 1px solid #e3e3e3;
                cursor: pointer;
                transition: all 0.3s;

                &:hover,
                &.active {
                    color: #333;
                    border: 1px solid #b3b3b3;
                    background-color: #f5f5f5;
                }
            }
        }

        .logistics-info-box {
            width: 100%;
            height: 400px;
            background: #f9fafc;
            border-radius: 10px;
            margin-top: 20px;
            padding: 30px 0 30px 40px;
            display: flex;
            column-gap: 182px;

            .logistics-info-left {
                display: flex;
                flex-direction: column;
                width: 230px;

                .logistics-img {
                    width: 230px;
                    height: 130px;
                }

                .logistics-info-title {
                    color: #333;
                    font-size: 18px;
                    margin-top: 32px;
                    margin-bottom: 32px;
                }

                .logistics-info-content {
                    display: flex;
                    flex-direction: column;
                    row-gap: 11px;

                    .logistics-info-item {
                        display: flex;
                        align-items: center;

                        .label {
                            color: #333;
                            font-size: 14px;
                        }

                        .value {
                            color: #333;
                            font-size: 14px;
                        }
                    }
                }
            }

            .logistics-info-right {
                flex: 1;
                height: 100%;
                overflow-y: auto;
                padding-right: 20px;

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 4px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #d9d9d9;
                    border-radius: 4px;
                }

                &::-webkit-scrollbar-button {
                    display: none !important;
                }

                .logistics-router-box {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;

                    .empty-tracking {
                        text-align: center;
                        color: #999;
                        padding: 60px 0;
                        font-size: 14px;
                    }

                    .logistics-router-item {
                        width: 100%;
                        min-height: 30px;
                        display: flex;
                        align-items: flex-start;
                        column-gap: 24px;
                        line-height: 17px;

                        .router-item-left {
                            color: #666;
                            font-size: 12px;
                            min-width: 140px;

                            &.active {
                                color: #000;
                                font-weight: bold;
                            }
                        }

                        .router-item-center {
                            width: 10px;
                            height: 10px;
                            background: #c9c9c9;
                            border-radius: 50%;
                            position: relative;
                            z-index: 1;
                            flex-shrink: 0;
                            margin-top: 4px;

                            &.active {
                                background: #ff5967;
                                box-shadow: 0 0 0 2.5px #ff5967;
                            }

                            &::after {
                                position: absolute;
                                content: '';
                                width: 2px;
                                background: #c9c9c9;
                                left: 50%;
                                transform: translateX(-50%);
                                top: 14px;           // 圆点底部(10px+4px margin-top)之后开始
                                height: calc(100% + 48px);  // 延伸到下一个节点
                                z-index: -1;
                            }
                        }

                        .router-item-right {
                            display: flex;
                            flex-direction: column;
                            row-gap: 4px;
                            flex: 1;

                            .status {
                                color: #666;
                                font-size: 14px;
                                font-weight: bold;

                                &.active {
                                    color: #ff5967;
                                }
                            }

                            .status-desc {
                                color: #666;
                                font-size: 12px;
                                padding-bottom: 24px;

                                &.active {
                                    color: #333;
                                }
                            }
                        }

                        &:first-child {
                            .router-item-center {
                                &::after {
                                    top: 14px;
                                    height: calc(100% + 56px);   // 首项文字可能更长，多延伸一些
                                }
                            }
                        }

                        &:last-child {
                            .router-item-center {
                                &::after {
                                    display: none !important;
                                }
                            }
                        }
                    }
                }
            }
        }

        .logistics-products-list-title {
            color: #666;
            font-size: 14px;
            margin-top: 25px;
        }

        .logistics-products-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 24px;

            .products-item {
                flex: 0 0 calc((100% - 30px) / 3);
                min-width: 300px;
                max-width: 500px;
                border: 1px solid #e3e3e3;
                border-radius: 10px;
                padding: 16px;
                display: flex;
                column-gap: 16px;
                align-items: center;

                .products-cover {
                    width: 96px;
                    height: 96px;
                    border: 1px solid #e3e3e3;
                    border-radius: 8px;
                    object-fit: cover;
                }

                .title-spec-num {
                    display: flex;
                    flex-direction: column;
                    row-gap: 14px;
                    flex: 1;

                    .title {
                        width: 100%;
                        color: #333;
                        font-size: 14px;
                        display: -webkit-box;
                        line-clamp: 2;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                    }

                    .spec-num {
                        display: flex;
                        column-gap: 24px;
                        align-items: center;

                        .spec {
                            display: flex;
                            column-gap: 10px;
                            font-size: 14px;

                            .color {
                                color: #666;
                            }

                            .size {
                                color: #666;
                            }
                        }

                        .num {
                            font-size: 14px;
                            color: #666;
                        }
                    }
                }
            }

            .no-products {
                width: 100%;
                text-align: center;
                color: #999;
                font-size: 14px;
                padding: 40px 0;
            }
        }
    }
}

/* 响应式适配 */
@media screen and (max-width: 1240px) {
    .order-remark {
        .content {
            width: 95%;
            margin: 0 auto;
        }
    }
}

@media screen and (max-width: 768px) {
    .order-remark {
        .content {
            width: 100%;
            height: 100%;
            max-height: 100%;
            border-radius: 0;
            padding: 16px;
        }

        .order-logistics-box {
            .logistics-info-box {
                flex-direction: column;
                height: auto;
                padding: 20px;
                column-gap: 0;

                .logistics-info-left {
                    width: 100%;
                    margin-bottom: 20px;

                    .logistics-img {
                        width: 100%;
                        height: auto;
                    }
                }

                .logistics-info-right {
                    height: 300px;
                }
            }

            .logistics-products-list {
                .products-item {
                    flex: 0 0 100%;
                    min-width: auto;
                    max-width: none;
                }
            }
        }
    }
}
</style>